$(function () {
    var image = {},
        types = ["lens", "arms", "frame"],
        concatUrls = function () {
            var urls = [];
            types.map(function (type) {
                urls.push(image[type]);
            });
            return urls.join(',');
        },
        img,
        urlArray = [],
        imgArray = [],
        currentType = 'lens';

              var size, 
              	  space = $('.builder_left .parts_wrap').outerWidth();
              if (space < 480) {
                size = 'large';
              } else if (space <= 600 && space >= 480) {
                size = 'grande';
              } else {
                size = '1024x1024';
              }  

    // Events
    $(".select_part input").click(function () {
        currentType = $(this).val();
        types.map(function (type) {
            $("#" + type).css("display", "none");
        });

        $("#" + currentType).css("display", "block");
    });

/*
  $("#product-buy-now").click(function () {
        var i, customIndex = 0;
        if (!$.jStorage.get("urls")) {
            customIndex = 1;
            urlArray.push("/products/custom-sili-" + customIndex);
            imgArray.push(img);
            $.jStorage.set("urls", urlArray);
            $.jStorage.set("imgs", imgArray);
        } else {
            urlArray = $.jStorage.get("urls");
            imgArray = $.jStorage.get("imgs");
            for (i = 0; i < imgArray.length; i++) {
                if (imgArray[i] === img) {
                    customIndex = i + 1;
                    i = imgArray.length;
                }
            }
            if (customIndex === 0) {
                customIndex = urlArray.length + 1;
                urlArray.push("/products/custom-sili-" + customIndex);
                imgArray.push(img);
                $.jStorage.set("urls", urlArray);
                $.jStorage.set("imgs", imgArray);
            }
          else if (customIndex > 4) { $.jStorage.flush(); }
        }
        document.location.href = "http://alphabeta-5.myshopify.com/products/custom-sili-" + customIndex + "?img=" + img;
          
    });

/*  
    $("#product-buy-now").click(function () {
        document.location.href = "/pages/custom-sili-confirm";
    });  
*/ 
  
    // Initialization
    (function () {
      	var index;
        var appendDiv = function (type) {
                $("#" + type).empty();
                for (index = 0; index < ImageUrl[type].length; index++ ) {
                  src = ImageUrl[type][index];
                  src = src.replace('1024x1024','thumb');
                    $("#" + type).append('<div id="part'+ index +'" class="pick_col ' + type + '" style="background-image: url(' + src + ')"></div>');
                }
                  	$("#" + type + "_col").append(get_sku(ImageUrl[type][0]));
            },
            insertImage = function (type) {
              src = image[type];
              src = src.replace('1024x1024', size);
                $("#" + type + "_pan").html('<img id="img_' + type + '" crossOrigin="Anonymous"  src="' + src + '"/>');
            };

        types.map(function (type) {
            image[type] = ImageUrl[type][0];
        });
        image.bg = BackgroundUrl;
        img = concatUrls();

        insertImage("bg");
        if ($(".builder").length) {
            types.map(function (type) {
                insertImage(type);
            });
        }

        types.map(function (type) {
            appendDiv(type);
        });

        types.map(function (type) {
            $("#" + type + " div:first-child").addClass("selected");
        });

        $(".select_part input[value=" + currentType + "]").click();
      
    }());

  

    $(".pick_col").click(function () {
        var url = $(this).css("background-image");
        url = url.replace(/url\(["]*([^"]*)["]*\).*/g, "$1");
        url = url.replace('thumb',size);

        $("#" + currentType + " .pick_col").removeClass("selected");
        $("#" + currentType + "_pan").html("<img src= " + url + " />");
        $("#" + currentType + "_col").html(get_sku(url));

        $(this).addClass("selected");
        image[currentType] = url;
        img = concatUrls();
    });

  (function () {
    var i;
      $('#lens .pick_col').click(function (){
        i = $(this).attr('id').slice(4);
        $('#product-select-option-0 option:eq('+ i +')').prop('selected', true).change();
      });
      $('#frame .pick_col').click(function (){
        i = $(this).attr('id').slice(4);
        $('#product-select-option-1 option:eq('+ i +')').prop('selected', true).change();
      });
      $('#arms .pick_col').click(function (){
        i = $(this).attr('id').slice(4);
        $('#product-select-option-2 option:eq('+ i +')').prop('selected', true).change();
      });    
    
  }());
});